import React, {  useEffect} from 'react';
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { Button } from '@mui/material';
import { Link,useNavigate } from "react-router-dom";
import AxiosFetchData from '../pages/AxiosFetchData';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
export default function BackButton() {
  const [open, setOpen] = React.useState(false);
  
  const Navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('ReturnUrl');

  useEffect(() => {
    
    if(myParam != null){
      setOpen(true);
    }
  }, []);
  
  const handleClick = (event, reason) => {
    Navigate('/' + myParam);
  };
 
  

  return (
    <div>
      {open ? (
         <button style={{visibility : open}} id="btnBack"  onClick={handleClick} className='btn btn-primary btn-sm' title="Back"><ChevronLeftIcon sx={{ fontSize: 10 }}/> back</button>  
      ):(
          <div>&nbsp;</div>
      )}
     
       
    </div>
  );
}